<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-1 text-center" v-text="'Świetnie!'" />
        </template>

        <div class="text-center mb-3">
            <a-icon icon="Ok" width="40px" height="40px" />
        </div>
        <p
            v-text="content"
            class="text-primary text-center font-weight-semi"
        />

        <div class="thanks-modal__shop" v-for="shop in shopsList" :key="shop.id">
            <a-icon icon="Ok" width="16" height="16" />
            <span v-text="shop.full_name + ', ' + shop.fullAddress" class="ml-2" />
        </div>

        <template #footer>
            <the-btn
                :text="rejectBtnText"
                class="btn-outline-custom"
                @click="goToDrs"
            />
            <the-btn
                text="Przejdź do listy zgłoszeń"
                class="btn-secondary"
                @click="goToIntegrations"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { CONFIG_MODES } from '@/store/modules/drs/tariffs.module'

const MODAL_MODES = {
    CONFIGURATION: 'configuration',
    EDIT: 'edit',
    PAYMENT: 'payment'
}

const CONTENT = {
    [MODAL_MODES.CONFIGURATION]: 'Konfiguracja pakietu przebiegła pomyślnie. Wysokość opłat znajdziesz w kafelku “Ustawienia płatności”. Do prawidłowego działania funkcjonalności niezbędna jest integracja urządzeń. Możesz teraz zgłosić chęć integracji dla wybranych sklepów, klikając w przycisk “Przejdź do listy zgłoszeń”.',
    [MODAL_MODES.EDIT]: 'Zaktualizowaliśmy wartość pakietu - wysokość opłaty dostępna jest w kafelku “Ustawienia płatności”. Do prawidłowego działania funkcjonalności niezbędna jest integracja urządzeń. Możesz teraz zgłosić chęć integracji dla wybranych sklepów, klikając w przycisk “Przejdź do listy zgłoszeń”.',
    [MODAL_MODES.PAYMENT]: 'Płatność przebiegła pomyślnie. Operator bramki płatniczej prześle potwierdzenie płatności na wskazany wcześniej adres e-mail. Do prawidłowego działania funkcjonalności niezbędna jest integracja urządzeń. Możesz teraz zgłosić chęć integracji dla wybranych sklepów, klikając w przycisk “Przejdź do listy zgłoszeń”.'
}

export default {
    data: () => ({
        isDrsTest: true
    }),

    computed: {
        ...mapGetters('drsTariffs', ['configMode']),

        modalArgs() {
            return this.$store.getters.modalState.args
        },

        isPaymentMode() {
            return this.modalArgs && this.modalArgs.mode === 'payment'
        },

        modalMode() {
            if (this.modalArgs && this.modalArgs.mode === 'payment') {
                return MODAL_MODES.PAYMENT
            }

            if (this.configMode === CONFIG_MODES.EDIT) {
                return MODAL_MODES.EDIT
            }

            return MODAL_MODES.CONFIGURATION
        },

        content() {
            return CONTENT[this.modalMode]
        },

        rejectBtnText() {
            return this.isLicencesRoute || this.isPaymentRoute
                ? 'Zamknij'
                : 'Przejdź do panelu System Kaucyjny'
        },

        shopsList() {
            return this.$store.getters.getModal.args.shopsList
        },

        isLicencesRoute() {
            return this.$router.currentRoute.name === 'drs-stores-licenses'
        },

        isPaymentRoute() {
            return this.$router.currentRoute.name === 'drs-payment'
        }
    },
    methods: {
        ...mapActions('drsLicenses', ['fetchPackage']),
        ...mapActions('payment', ['loadUpcomingPayment']),

        goToDrs() {
            if (this.isLicencesRoute) {
                this.fetchPackage()
            } else if (!this.isPaymentRoute) {
                this.$router.push({ name: 'drs' })
            }

            this.$store.dispatch('toggleModal', false)
        },

        goToIntegrations() {
            this.$router.push({ name: 'drs-integrations' })
            this.$store.dispatch('toggleModal', false)
        }
    },

    created() {
        this.$store.$storage.removeItem('tariffConfig')
    }
}
</script>

<style lang="scss">
.thanks-modal__shop {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    border: 1px solid var(--color-gray-200);
    border-radius: var(--border-radius);
    padding: 1rem;
    color: var(--color-primary);

    a-icon {
        margin-right: 8px;
    }
}
</style>